import React, { useState } from 'react';
import classes from './LanguageSwitcher.module.scss';
import HuFlag from '../../assets/HU.png';
import EnFlag from '../../assets/EN.png';
import EsFlag from '../../assets/ES.png';
import RoFlag from '../../assets/RO.png';
import DeFlag from '../../assets/DE.png';
import {startLoading } from '../../lib/legacy';
import { HiMiniChevronDown, HiMiniChevronUp } from 'react-icons/hi2';

function LanguageSwitcher(props: LanguageSwitcherProps) {
	const [open, setOpen] = useState(false);
	const localStorageLanguage = window.localStorage.getItem('i18nextLng') || 'hu';

	const changeLanguage = (language: string) => {
		startLoading();
		window.localStorage.setItem('i18nextLng', language);
		window.location.reload();
	};

	const getFlag = (languageCode: any) => {
		switch (languageCode) {
			case 'hu':
				return HuFlag
			case 'en':
				return EnFlag
			case 'es':
				return EsFlag
			case 'ro':
				return RoFlag
			case 'de':
				return DeFlag
		}
	}

	return (
		<div className={classes.languageSelectContainer}>
			<div className={classes.languageBox} onClick={() => setOpen((prevState: any) => !prevState)}>
				<img
					className={classes.languageIcon}
					style={{width: '20px', height: '20px'}}
					src={getFlag(localStorageLanguage)}
					alt={localStorageLanguage?.toUpperCase()}
				/>
				<span
					className={classes.languageName}>{props.systemLanguages.find((item: any) => item.code.split('-')[0] === localStorageLanguage).name}</span>
				{open ? <HiMiniChevronUp className={classes.languageName}/> :
					<HiMiniChevronDown className={classes.languageName}/>}
			</div>
			{open && (
				<div className={classes.languageBoxSelector} onClick={() => setOpen((prevState: any) => !prevState)}>
					{props.systemLanguages.filter((item: any) => item.code.split('-')[0] !== localStorageLanguage).map((language: any) => (
						<div className={classes.languageBox} onClick={() => changeLanguage(language.code.split('-')[0])}>
							<img
								className={classes.languageIcon}
								style={{width: '20px', height: '20px'}}
								src={getFlag(language.code.split('-')[0])}
								alt={language.code.split('-')[0].toUpperCase()}
							/>
							<span className={classes.languageName}>{language.name}</span>
						</div>
					))}
				</div>
			)}
		</div>
	);
}

interface LanguageSwitcherProps {
	systemLanguages: any;
	className?: string;
}

export default LanguageSwitcher;
